class AnchorScroll {
    constructor($buttons) {
        this.$buttons = $buttons;
        this.$body = $('html, body');
    }

    bindEvent() {
        this.$buttons.on('click', this._scrollTo.bind(this));
    }

    _scrollTo(event) {
        const num = 3;
        const currentPage = location.pathname;
        const $currentButton = $(event.target);
        const href = $currentButton.attr('href');
        const index = href.indexOf('#');
        const page = href.slice(0, index);

        if (!currentPage.match(page)) {
            return;
        }

        const target = href.slice(index);
        const currentPosition = $(target).offset().top;
        const scrollTime = currentPosition / num;

        event.preventDefault();

        this.$body.animate({scrollTop: $(target).offset().top}, scrollTime);
    }
}

export default AnchorScroll;
